// Modules
import { produce } from 'immer'

// Constants
import { defaultProps } from 'components/TVChartContainer/constants'

import { graphResolutionValueKey } from 'constants/index'

// Types
import {
  GET_CURRENCY_MARKET_LIST,
  SET_ACCORDION_TITLES_LIST,
  SET_CURRENCY_MAP_MARKET_LIST,
  SET_CURRENCY_MARKET_LIST,
  SET_CURRENCY_MARKET_LIST_LOADING,
  SET_CURRENT_ACTIVE_CURRENCY_INFO,
  SET_INTERVAL_GRAPH_VALUE,
  SET_OPEN_ACCORDION_PANEL_GROUP_ID,
  SET_OPEN_ACCORDION_PANEL_GROUP_LIST,
  SET_UPDATED_CURRENCIES_LIST,
  WS_CURRENCY_MARKET_CHANGE_CURRENCY_VALUE,
  WS_CURRENCY_MARKET_MESSAGE_RECEIVED_UPDATE_GLOBAL_LIST,
} from 'store/actions/CurrencySocket/types'

const initialState = {
  currencyList: null,
  currencyListUpdated: null,
  currencyListLoading: true,

  currencyMap: null,

  intervalGraphValue: localStorage.getItem(graphResolutionValueKey) || defaultProps.interval,

  // open currency  (need for updating from socket)
  currentActiveCurrencyInfo: null,

  // accordion
  openPanelGroupId: null,
  openPanelGroupList: null,
  accordionTitlesList: null,
}

const currencySocketReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_OPEN_ACCORDION_PANEL_GROUP_ID:
      return produce(state, (draft) => {
        draft.openPanelGroupId = action.payload
      })

    case SET_OPEN_ACCORDION_PANEL_GROUP_LIST:
      return produce(state, (draft) => {
        draft.openPanelGroupList = action.payload
      })

    case SET_UPDATED_CURRENCIES_LIST:
      return produce(state, (draft) => {
        draft.currencyListUpdated = action.payload
      })

    case SET_ACCORDION_TITLES_LIST:
      return produce(state, (draft) => {
        draft.accordionTitlesList = action.payload
      })

    case SET_CURRENT_ACTIVE_CURRENCY_INFO:
      return produce(state, (draft) => {
        draft.currentActiveCurrencyInfo = action.payload
      })

    // ===========================
    case SET_INTERVAL_GRAPH_VALUE:
      return produce(state, (draft) => {
        draft.intervalGraphValue = action.payload
      })

    case SET_CURRENCY_MAP_MARKET_LIST:
      return produce(state, (draft) => {
        draft.currencyMap = action.payload
      })

    case SET_CURRENCY_MARKET_LIST:
      return produce(state, (draft) => {
        draft.currencyList = action.payload
      })

    case GET_CURRENCY_MARKET_LIST:
      return produce(state, (draft) => {
        draft.currencyListLoading = true
      })

    case SET_CURRENCY_MARKET_LIST_LOADING:
      return produce(state, (draft) => {
        draft.currencyListLoading = action.payload
      })

    case WS_CURRENCY_MARKET_CHANGE_CURRENCY_VALUE:
      return produce(state, (draft) => {
        const elementSocket = action.payload

        // // Skip if the required objects are not available
        if (!draft.openPanelGroupList) return

        if (Array.isArray(elementSocket)) {
          // Process multiple elements at once
          elementSocket.forEach((elS) => updateCurrencyValueNew(elS, draft))
        } else {
          updateCurrencyValueNew(elementSocket, draft)
        }
      })

    case WS_CURRENCY_MARKET_MESSAGE_RECEIVED_UPDATE_GLOBAL_LIST:
      return produce(state, (draft) => {
        const elementSocket = action.payload

        // Skip if the required objects are not available
        if (!draft.currencyListUpdated || !draft.currencyMap) return

        if (Array.isArray(elementSocket)) {
          // Process multiple elements at once
          elementSocket.forEach((elS) => updateCurrencyValue(elS, draft))
        } else {
          updateCurrencyValue(elementSocket, draft)
        }
      })

    // case WS_CURRENCY_MARKET_CHANGE_CURRENCY_VALUE:
    //   return produce(state, (draft) => {
    //     const elementSocket = action.payload
    //
    //     // Skip if the required objects are not available
    //     if (!draft.currencyList || !draft.currencyMap) return
    //
    //     if (Array.isArray(elementSocket)) {
    //       // Process multiple elements at once
    //       elementSocket.forEach((elS) => updateCurrencyValue(elS, draft))
    //     } else {
    //       updateCurrencyValue(elementSocket, draft)
    //     }
    //   })

    default:
      return state
  }
}
export default currencySocketReducer

// for updating price of currency
const updateCurrencyValueNew = (elementSocket, draft) => {
  const group = elementSocket?.group
  const symbol = elementSocket?.symbol
  const close = elementSocket?.close

  // If no price change is available, we return early
  if (close === undefined) return

  const currencyMapGroup = draft.currencyMap?.[group]

  // If group or symbol does not exist, skip processing (index can be 0, so check for undefined)
  if (!currencyMapGroup || currencyMapGroup[symbol] === undefined) return

  const indexOfElement = currencyMapGroup[symbol]

  // Skip if the target currency is not found or the open panel shows another group
  // (the index is only valid within the group the message belongs to)
  const targetCurrency = draft.openPanelGroupList?.[indexOfElement]
  if (!targetCurrency || targetCurrency.name !== symbol) return

  targetCurrency.price = close
}

// for updating price of currency
const updateCurrencyValue = (elementSocket, draft) => {
  const group = elementSocket?.group
  const symbol = elementSocket?.symbol
  const close = elementSocket?.close

  // If no price change is available, we return early
  if (close === undefined) return

  const currencyMapGroup = draft.currencyMap?.[group]

  // If group or symbol does not exist, skip processing (index can be 0, so check for undefined)
  if (!currencyMapGroup || currencyMapGroup[symbol] === undefined) return

  const indexOfElement = currencyMapGroup[symbol]

  // Skip if the target currency is not found
  const targetCurrency = draft.currencyListUpdated?.[group]?.[indexOfElement]
  if (!targetCurrency) return

  targetCurrency.price = close
}
